import { authenticatedApiFetch } from '../utils/utils'

export const createQcmQuestionPointService = async (data) => {
	const res = await authenticatedApiFetch('/qcm-question-points/', { method: 'POST', body: JSON.stringify(data) })
		.then(res => res.json())
		.catch(error => console.error(error))
	return res
}
